import { render, staticRenderFns } from "./RecordingReport.vue?vue&type=template&id=4b135a1d&scoped=true&"
import script from "./RecordingReport.vue?vue&type=script&lang=js&"
export * from "./RecordingReport.vue?vue&type=script&lang=js&"
import style0 from "./RecordingReport.vue?vue&type=style&index=0&id=4b135a1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b135a1d",
  null
  
)

export default component.exports